<template>
  <el-dialog title="添加子任务" top="0px" width="66%" class="SubDialog" :visible.sync="dialogFormVisible" append-to-body>
    <el-form :model="form" ref="ruleForm" :rules="rules" style="text-align: left;" class="demo_ruleForm">
      <el-row>
      	<el-col :span="12">
      		<el-form-item label="任务编号" :label-width="formLabelWidth">
      			<span>{{task.INSTANCE}}</span>
      		</el-form-item>
      	</el-col>
      	<el-col :span="12">
      		<el-form-item label="创建人" :label-width="formLabelWidth">
      			<span>{{task.CREATEUSERNAME}}</span>
      		</el-form-item>
      	</el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <el-form-item label="任务标题" prop="TaskTitle" :label-width="formLabelWidth">
            <el-input v-model="form.TaskTitle" placeholder="任务标题" autocomplete="off"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-form-item label="接收方" :label-width="formLabelWidth">
          <ayb-select-receiver ref="ReceiveUser" :isRadio="true" setWidth="380px" @getValue="receiverGetValue"></ayb-select-receiver>
        </el-form-item>
        <!-- <el-col :span="12">
                <el-form-item label="服务台" :label-width="formLabelWidth">
                  <el-select v-model="Reception" placeholder="请选择服务台">
                    <el-option v-for="item in ReceptionList" :key="item.ID " :label="item.NAME " :value="item.ID "></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="执行人" :label-width="formLabelWidth" style="width: 150px;">
                  <selectContactor ref="selectedExcuteUser" :idArray="userId" :isRadio="true" @getValue="ExcuteUserGetValue"></selectContactor>
                </el-form-item>
              </el-col> -->
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="任务等级" :label-width="formLabelWidth">
            <el-select v-model="form.TaskLevelSel" placeholder="请选择 ">
              <el-option v-for="item in taskLevel" :key="item.value" :label="item.label" :value="item.value"> </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="任务类型" :label-width="formLabelWidth">
            <el-select v-model="TASKTYPE" placeholder="请选择 ">
              <el-option v-for="item in TaskTypeList" :key="item.ID" :label="item.NAME" :value="item.ID"> </el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <el-form-item label="预计时间" :label-width="formLabelWidth">
            <el-date-picker v-model="form.EstimatedTime" type="datetimerange" align="right" unlink-panels range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" :picker-options="pickerOptions2">
            </el-date-picker>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <el-form-item label="预计工作量" :label-width="formLabelWidth">
            <el-input-number v-model="form.PLANWORKLOAD" style="width: 150px;"></el-input-number>
            <el-select v-model="form.PLANWORKLOADUNIT" style="width: 80px;" placeholder="请选择活动区域">
              <el-option label="小时" value="0"></el-option>
              <el-option label="天" value="1"></el-option>
              <el-option label="周" value="2"></el-option>
              <el-option label="月" value="3"></el-option>
              <el-option label="季" value="4"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <el-form-item label="内容描述" :label-width="formLabelWidth">
            <editor v-model="form.CONTENT" :isClear="isClear"></editor>
            <!-- <el-input type="textarea" :rows="4" placeholder="请输入记录详情" v-model="WorkContent">
                                                                          </el-input> -->
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button type="primary" :disabled="isDisabled" @click="onSubmit('ruleForm')">确 定</el-button>
      <el-button type="danger" @click="dialogFormVisible = false">关 闭</el-button>
    </div>
  </el-dialog>
</template>

<script>
  import selectContactor from '@/components/basicData/selectContactorComponent.vue'
  import selectServiceCenter from "@/components/basicData/selectServiceCenter.vue";
  // import $ from 'jquery'
  import {
    regular
  } from '@/api/modules/basicData/location'
  import Editor from '@/components/common/editor'
  import {
    getToken
  } from '@/util/auth'
  import {
    // GetTaskTypeList,
    acceptTask,
    GetAllSubTasksByParentTaskId,
    GetAllManageServerCenterByUserId,
    AddAssignTask
  } from "@/api/modules/basicData/task";
  import $http from "@/api/index";
  export default {
    components: {
      selectContactor,
      selectServiceCenter,
      Editor,
    },
    data() {
      var checknum = (rule, value, callback) => {
        value = this.trim(value);
        if (!value) {
          callback(new Error('不能为空'));
          this.time('ruleForm', 'TaskTitle')
        } else {
          callback()
        }
        // var judge = regular('chinese', this.form.TaskTitle);
        // if (judge != true) {
        //   callback(judge)
        //   this.time('ruleForm', 'TaskTitle')
        // } else {
        //   callback()
        // }
      };
      return {
        dialogFormVisible: false,
        user: {},
        userId: [],
        type: 0,
        isClear: true,
        Reception: '',
        ReceptionList: JSON.parse(localStorage.getItem('ManageServerCenter')),
        timetype: "1",
        TASKTYPE: '',
        isDisabled: false,
        rules: {
          TaskTitle: [{
            validator: checknum,
            trigger: 'blur'
          }]
        },
        taskLevel: [{
            value: "0",
            label: "重要且紧急"
          },
          {
            value: "1",
            label: "重要不紧急"
          },
          {
            value: "2",
            label: "紧急不重要"
          },
          {
            value: "3",
            label: "不重要不紧急"
          }
        ],
        eventInfo: {
          CONTENT: '',
          SERVERCENTERNAME: '',
          SERVERCENTERID: '',
          EVENTNAME: '',
          EVENTTYPENAME: '',
          EVENTTYPEID: '',
          TASKDEGREE: '',
          ADDRESSSEL: '',
        },
        TaskTypeList: "",
        form: {
          TaskTitle: "",
          Executor: "",
          TaskLevelSel: "1",
          EstimatedTime: [],
          PLANWORKLOAD: 1,
          PLANWORKLOADUNIT: '0',
          CONTENT: '',
          TASKTYPE: '',
          EXCUTEUSERID: '',
          EXCUTEUSERNAME: ''
        },
        pickerOptions2: {
          shortcuts: [{
              text: "最近一周",
              onClick(picker) {
                const end = new Date();
                const start = new Date();
                start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                picker.$emit("pick", [start, end]);
              }
            },
            {
              text: "最近一个月",
              onClick(picker) {
                const end = new Date();
                const start = new Date();
                start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                picker.$emit("pick", [start, end]);
              }
            },
            {
              text: "最近三个月",
              onClick(picker) {
                const end = new Date();
                const start = new Date();
                start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                picker.$emit("pick", [start, end]);
              }
            }
          ]
        },
        formLabelWidth: "120px",
        tableData: []
      };
    },
    mounted() {
      this.user = getToken();
      let TaskType = JSON.parse(localStorage.getItem('TaskType'))
      this.TaskTypeList = TaskType;
      this.TASKTYPE = TaskType[TaskType.length - 1].ID;
      // this.GetTaskTypeList();
      // this.GetAllManageServerCenterByUserId(this.user.userId);
    },
    methods: {
      // GetTaskTypeList() {
      //   //任务类型
      //   GetTaskTypeList().then(res => {
      //     this.TaskTypeList = res;
      //     this.TASKTYPE = res[res.length - 1].ID;
      //   });
      // },
      getServerCenter(val) {
        this.searchParams.ServerCenterIds = val.join(',');
      },
      ExcuteUserGetValue(data) {
        // this.form.EXCUTEUSERID=
        if (!data) return;
        const row = data[0];
        this.form.EXCUTEUSERID = row.UserId;
        this.form.EXCUTEUSERNAME = row.Name;
      },
      /** */
      // GetAllManageServerCenterByUserId() {
      //   GetAllManageServerCenterByUserId(this.user.userId).then(res => {
      //     this.ReceptionList = res;
      //   });
      // },
      receiverGetValue(value) {
        if (value.length > 0) {
          if (value[0].ContactType == 1) { // 如果选择的是人员 就要禁用接收人
            // this.excuteHumanDisable = true;
            // this.$refs.excuteHuman.reset();
            this.form.EXCUTEUSERID = value[0].Key;
            this.form.EXCUTEUSERNAME = value[0].Name;
            this.eventInfo.SERVERCENTERID = '';
            this.eventInfo.SERVERCENTERNAME = '';
          } else {
            this.form.EXCUTEUSERID = '';
            this.form.EXCUTEUSERNAME = '';
            this.eventInfo.SERVERCENTERID = value[0].Key;
            this.eventInfo.SERVERCENTERNAME = value[0].Name;
          }
        } else {
          this.form.EXCUTEUSERID = '';
          this.form.EXCUTEUSERNAME = '';
          this.eventInfo.SERVERCENTERID = '';
          this.eventInfo.SERVERCENTERNAME = ''
        }
      },
      /**添加子任务提交 */
      onSubmit(formName) {
        if (!this.isDisabled) {
          this.isDisabled = true;
          this.$refs[formName].validate((valid) => {
            if (valid) {
              // var formData = new FormData();
              if (!this.form.EXCUTEUSERID && !this.eventInfo.SERVERCENTERID) {
                this.$message({
                  type: 'info',
                  message: '接收方不为空'
                });
                this.isDisabled = false;
                return false;
              }
              const date = new Date();
              let taskInfo = {
                "STATE": 0,
                "CREATESOURCE": 3,
                //创建任务的人（此运维人员）
                "CREATEUSERID": this.user.userId,
                "CREATEUSERNAME": this.user.realName,
                "CREATEDEPTID": this.user.departmentId,
                "CREATEDEPTNAME": this.user.departmentName,
                "CREATECOMPANYID": this.user.companyId,
                "CREATECOMPANYNAME": this.user.companyId,
                "CREATETIME": date,
                "EVALUTIONTIME": date,
                //报告人为事件里的人
                "PROPOSERID": this.task.PROPOSERID,
                "PROPOSERNAME": this.task.PROPOSERNAME,
                "PROPOSERDEPTID": this.task.PROPOSERDEPTID,
                "PROPOSERDEPTNAME": this.task.PROPOSERDEPTNAME,
                "PROPOSERCOMPANYID": this.task.PROPOSERCOMPANYID,
                "PROPOSERCOMPANYNAME": this.task.PROPOSERCOMPANYNAME,
                "PARENTID": this.task.ID,
                "EVENTINSTANCE": this.task.EVENTINSTANCE,
                "EVENTID": this.task.EVENTID,
                "EVENTNAME": this.task.EVENTNAME,
                "ROOTID": this.task.ROOTID,
                "PARENTNAME": this.task.TASKNAME,
                "TASKTYPE": this.eventInfo.EVENTTYPEID,
                "TASKTYPENAME": this.eventInfo.EVENTTYPENAME,
                'SERVERCENTERNAME': this.eventInfo.SERVERCENTERNAME,
                'SERVERCENTERID': this.eventInfo.SERVERCENTERID,
                // 'EVENTTYPENAME': this.eventInfo.EVENTTYPENAME,
                // 'EVENTTYPE': this.eventInfo.EVENTTYPEID,
                'PLANWORKLOAD': this.form.PLANWORKLOAD,
                'PLANWORKLOADUNIT': this.form.PLANWORKLOADUNIT
              }
              taskInfo.EXCUTEUSERID = this.form.EXCUTEUSERID;
              taskInfo.EXCUTEUSERNAME = this.form.EXCUTEUSERNAME;
              taskInfo.QUANITIY = 1;
              taskInfo.TASKNAME = this.form.TaskTitle;
              taskInfo.CONTENT = this.form.CONTENT;
              let EstimatedTime = this.form.EstimatedTime
              // let ENDDATE = this.form.BEGINDATE;
              taskInfo.ENDDATE = EstimatedTime[1];
              // let BEGINDATE = this.form.BEGINDATE;
              taskInfo.BEGINDATE = EstimatedTime[0];
              let jsonData = {
                "USERID": this.user.userId,
                "USERNAME": this.user.realName,
                "DEPTID": this.user.departmentId,
                "DEPTNAME": this.user.departmentName,
                "TASKID": this.task.ID,
                "ISNOTICEPERSON": false,
                "ALLOWCREATESUBTASK": false,
                "ISEVALUTIONPERSON": true,
              };
              // formData.append('TaskInfo', JSON.stringify(taskInfo)); //任务信息
              // formData.append('TaskMeMberInfo', JSON.stringify(jsonData)) //子任务信息
              AddAssignTask(taskInfo, jsonData).then(pmevent => {
                if (pmevent === 1) {
                  if (this.type === 0) {
                    this.$parent.initalTask();
                  }
                  this.dialogFormVisible = false;
                  this.$store.dispatch('changeTaskSource');
                  this.$message({
                    type: 'success',
                    message: '添加子任务成功。'
                  });
                  this.isDisabled = false;
                  this.onClear();
                } else {
                  this.$message({
                    type: 'error',
                    message: '添加子任务失败！'
                  });
                  this.isDisabled = false;
                }
              });
            } else {
              this.isDisabled = false;
              return false;
            }
          });
        }
      },
      onClear() {
        this.form = {
            TaskTitle: "",
            Executor: "",
            TaskLevelSel: "1",
            EstimatedTime: [],
            PLANWORKLOAD: 1,
            PLANWORKLOADUNIT: '0',
            CONTENT: '',
            TASKTYPE: '',
            EXCUTEUSERID: '',
            EXCUTEUSERNAME: ''
          },
          this.$refs.ReceiveUser.reset();
      }
    },
    computed: {
      task: function() {
        return this.$store.state.task.curTask;
      },
    },
    watch: {
      Reception: {
        handler(val, oldVal) {
          for (var i = 0; i < this.ReceptionList.length; i++) {
            if (this.ReceptionList[i].NAME == val) {
              this.eventInfo.SERVERCENTERNAME = this.ReceptionList[i].NAME
              this.eventInfo.SERVERCENTERID = this.ReceptionList[i].ID
              this.equipmentId = this.ReceptionList[i].ID
              break
            }
          }
        }
      },
      TASKTYPE: {
        handler(val, oldVal) {
          for (var i = 0; i < this.TaskTypeList.length; i++) {
            if (this.TaskTypeList[i].ID == val) {
              this.eventInfo.EVENTTYPENAME = this.TaskTypeList[i].NAME
              this.eventInfo.EVENTTYPEID = this.TaskTypeList[i].ID
              break
            }
          }
        }
      },
    }
  };
</script>
<style lang="less">
  .SubDialog {
    .el-dialog__body {
      padding: 10px 20px 0px 20px;
    }
  }
</style>
<style scoped>
  .dialog-footer {
    text-align: center;
  }
  .el-tabs__content {
    line-height: 20px;
  }
  .el-table__row {
    line-height: 20px;
  }
  .has-gutter tr {
    background-color: #f3f3f3;
    height: 38px;
  }
  .el-table__body-wrapper {
    background-color: white;
  }
  .el-table .cell {
    line-height: 13px;
  }
  .el-table__row .el-table_1_column_1,
  .el-table__row .el-table_1_column_2 {
    color: #0099ff;
  }
  .button .el-button {
    background: #ecf5ff;
    color: #0099ff;
  }
  .button {
    margin: 20px 0 0 20px;
    float: left;
  }
  .el-dialog__header {
    text-align: left;
  }
  .el-dialog__body {
    border-top: 1px solid #dcdfe6;
    border-bottom: 1px solid #dcdfe6;
    text-align: left;
  }
</style>
